import { getSalesAgentInfo } from 'merchant-api/spiceroad';
import { FormattedMessage } from 'react-intl';
import { formatPhone } from '@odmonorepo/odfunctions';
import { Button, Card, DefaultErrorPage, FormattedMessageDiv, useWizardContext } from '@odmonorepo/core-components';
import { checkoutSteps } from '../CheckoutWizard';

export const UpdateBank = () => {
  const { salesAgentInfo, isSalesAgentInfoLoading } = getSalesAgentInfo();
  if (isSalesAgentInfoLoading) return null;

  const contactName = salesAgentInfo?.name ? salesAgentInfo.name : undefined;
  const phoneLink = salesAgentInfo?.phone ? 'tel:+1' + salesAgentInfo.phone : undefined;
  const callButton = salesAgentInfo?.phone ? 'Call ' + formatPhone(salesAgentInfo.phone) : undefined;
  const { goToStep } = useWizardContext<typeof checkoutSteps>();

  return (
    <DefaultErrorPage
      title={<FormattedMessage id="customError.updateBank.title" />}
      message={<FormattedMessage id="customError.updateBank.message" />}
      contactName={contactName}
      contactDescription={salesAgentInfo?.name ? 'Loan Advisor' : undefined}
      link={phoneLink}
      CTA={callButton}
      redirectTo={
        <Button className='fs-6' variant='link' onClick={()=> goToStep("BANK_VERIFICATION")}>
          <FormattedMessage id="customError.updateBank.returnToBankInfo" />
        </Button>
      }
      cardTitle={<FormattedMessageDiv id="customError.updateBank.cardTitle" />}
    />
  )
}
export default UpdateBank;